import React from "react";
import "./pathway-type-badge.scss";
import PathwayTypeEnum from "../../enums/pathway-type.enum";

interface IPathwayTypeBadgeProps {
  pathwayType: string | null | undefined;
}

const PathwayTypeBadge = (props: IPathwayTypeBadgeProps) => {
  const { pathwayType } = props;
  return (
    <>
      {pathwayType?.toLocaleLowerCase() === "practice" ? (
        <div className="pathway-type-badge practice">{PathwayTypeEnum.PRACTICE}</div>
      ) : (
        <div className="pathway-type-badge instruction">{PathwayTypeEnum.INSTRUCTION}</div>
      )}
    </>
  );
};
export default PathwayTypeBadge;
